import { useTicker, num, pct } from "@/lib/format";

const Item = ({ q, clone }) => (
  <span data-testid={clone ? undefined : `ticker-${q.symbol.replace(/[^a-zA-Z0-9]/g, "").toLowerCase()}`} className="inline-flex items-baseline gap-2 px-5 border-r border-white/10">
    <span className="text-slate-400 font-sans font-semibold">{q.label}</span>
    <span className="text-white">{num(q.price)}</span>
    <span className={q.change_pct >= 0 ? "text-emerald-400" : "text-red-400"}>{q.change_pct >= 0 ? "▲" : "▼"} {pct(q.change_pct)}</span>
  </span>
);

export const Ticker = () => {
  const { data } = useTicker();
  const all = [...(data?.indices || []), ...(data?.stocks || [])];
  const time = data?.fetched_at ? new Date(data.fetched_at * 1000).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" }) : "--:--";
  return (
    <div data-testid="market-ticker" className="bg-[#020617] text-xs font-mono border-b border-white/5 flex items-center h-10 overflow-hidden">
      <span className="shrink-0 z-10 bg-[#020617] h-full flex items-center gap-2 pl-4 pr-3 border-r border-white/10">
        <span className="relative flex w-2 h-2"><span className="absolute inset-0 rounded-full bg-emerald-400 animate-ping opacity-70" /><span className="relative w-2 h-2 rounded-full bg-emerald-400" /></span>
        <span className="text-emerald-400 font-bold font-sans tracking-wider">LIVE</span>
        <span data-testid="ticker-updated" className="hidden sm:inline text-slate-500">{time}</span>
      </span>
      <div className="flex-1 overflow-hidden">
        {all.length > 0 ? (
          <div className="ticker-track flex w-max">
            {[0, 1].map((k) => <div key={k} className="flex" aria-hidden={k === 1}>{all.map((q) => <Item key={`${k}-${q.symbol}`} q={q} clone={k === 1} />)}</div>)}
          </div>
        ) : <span className="px-5 text-slate-500">Loading live market data…</span>}
      </div>
    </div>
  );
};
